export default __webpack_public_path__ + "static/media/card-exercise-icon.8b5107fe.svg";